import { useCountdown } from "../hooks/useCountdown";

export default function Countdown() {
  const { days, hours, mins, secs, label } = useCountdown();

  const units = [
    { value: days, text: "Days" },
    { value: hours, text: "Hours" },
    { value: mins, text: "Mins" },
    { value: secs, text: "Secs" },
  ];

  return (
    <div className="text-center">
      <div className="text-xs uppercase tracking-[3px] text-[#C9ED00] font-medium mb-4">
        {label}
      </div>
      <div className="flex gap-4 md:gap-6 justify-center" role="timer" aria-label="Countdown timer">
        {units.map((u) => (
          <div key={u.text} className="flex flex-col items-center">
            <div className="text-3xl md:text-5xl font-serif font-medium bg-white/5 border border-white/10 backdrop-blur-md rounded-2xl px-5 py-4 min-w-[70px] md:min-w-[90px] text-center text-white">
              {u.value}
            </div>
            <div className="text-[10px] uppercase tracking-widest text-white/50 mt-2">
              {u.text}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
